import { Stack, Box, CircularProgress, SxProps, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import appLoaderLang from '../langs/appLoaderLang';

type AppLoaderContentProps = {
	sx?: SxProps;
};

const AppLoaderContent = (props: AppLoaderContentProps) => {
	const { t } = useTranslation();
	return (
		<Stack alignItems="center" justifyContent="center" sx={{ height: '100vh', minHeight: '100vh', ...props.sx }}>
			<Box sx={{ color: 'white', textAlign: 'center', position: 'relative' }}>
				<Box>
					<CircularProgress color="secondary" disableShrink />
				</Box>
				<Typography color="primary" sx={{ margin: '30px' }}>
					{t(appLoaderLang.loading.tag)}
				</Typography>
			</Box>
		</Stack>
	);
};

export default AppLoaderContent;
